import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import './Sidebar.css';
import RoleGuard from '../../auth/RoleGuard';

const Sidebar = () => {
    const location = useLocation();
    const { user, isAdmin } = useAuthStore();

    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <Link to={isAdmin() ? "/admin" : "/dashboard"} className="sidebar-logo">
                    PE Wallet
                </Link>
            </div>

            <nav className="sidebar-nav">
                <RoleGuard adminOnly={true}>
                    <div className="nav-group">
                        <div className="nav-group-title">Admin</div>
                        <Link to="/admin" className={`nav-item ${isActive('/admin') && location.pathname === '/admin' ? 'active' : ''}`}>
                            Home
                        </Link>
                        <Link to="/admin/users" className={`nav-item ${isActive('/admin/users') ? 'active' : ''}`}>
                            Users
                        </Link>
                        <Link to="/admin/payments" className={`nav-item ${isActive('/admin/payments') ? 'active' : ''}`}>
                            Payments
                        </Link>
                        <Link to="/settings" className={`nav-item ${isActive('/settings') ? 'active' : ''}`}>
                            Me
                        </Link>
                    </div>
                </RoleGuard>

                {!isAdmin() && (
                    <div className="nav-group">
                        <div className="nav-group-title">Menu</div>
                        <Link to="/dashboard" className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
                            Home
                        </Link>
                        <Link to="/payments" className={`nav-item ${isActive('/payments') && !location.search.includes('tab=HISTORY') ? 'active' : ''}`}>
                            Payments
                        </Link>
                        <Link to="/payments?tab=HISTORY" className={`nav-item ${location.search.includes('tab=HISTORY') ? 'active' : ''}`}>
                            Transaction History
                        </Link>
                        <Link to="/settings" className={`nav-item ${isActive('/settings') ? 'active' : ''}`}>
                            Me
                        </Link>
                    </div>
                )}
            </nav>

            <div className="sidebar-footer">
                <div className="user-info">
                    <div className="user-name">{user?.mobileNumber || 'User'}</div>
                    <div className="user-role">{isAdmin() ? 'Administrator' : 'Verified'}</div>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
